import { useRef } from "react";
import { ChevronLeft, ChevronRight, CalendarDays } from "lucide-react";

export const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const todayStr = () => ymd(new Date());
export const shift = (s, n) => { const d = new Date(`${s}T12:00:00`); d.setDate(d.getDate() + n); return ymd(d); };
export const dayLabel = (s) => {
  const t = todayStr();
  if (s === t) return "Today";
  if (s === shift(t, -1)) return "Yesterday";
  if (s === shift(t, 1)) return "Tomorrow";
  return new Date(`${s}T12:00:00`).toLocaleDateString([], { weekday: "short", day: "numeric", month: "short" });
};
export const H = 3600e3;

export const needsPoll = (list) => {
  const n = Date.now();
  return list.some((m) => m.status === "live" || (m.status === "scheduled" && m.ts && m.ts * 1000 < n + 5 * 60e3 && m.ts * 1000 > n - 3 * H));
};

export function DateBar({ date, setDate, view, setView, liveCount }) {
  const ref = useRef(null);
  const btn = "w-10 h-10 rounded-full inline-flex items-center justify-center transition-colors";
  return (
    <div className="flex items-center gap-2 rounded-2xl bg-[#0F131B] border border-[#273042] p-2" data-testid="fb-date-bar">
      <button onClick={() => setView(view === "live" ? "day" : "live")} data-testid="fb-live-toggle" aria-pressed={view === "live"}
        className={`h-10 px-3.5 rounded-full text-xs font-extrabold tracking-wider inline-flex items-center gap-1.5 transition-colors ${view === "live" ? "bg-[#E11D2A] text-white" : "bg-[#1A202C] text-slate-200 hover:text-white"}`}>
        <span className="relative flex h-2 w-2"><span className={`absolute inline-flex h-full w-full rounded-full bg-current ${view === "live" ? "" : "animate-ping opacity-60"}`} /><span className="relative inline-flex rounded-full h-2 w-2 bg-current" /></span>
        LIVE{liveCount > 0 && <span className="ml-0.5 tabular-nums">{liveCount}</span>}
      </button>
      <button onClick={() => { setView("day"); setDate(shift(date, -1)); }} data-testid="fb-date-prev" aria-label="Previous day" className={`${btn} text-slate-300 hover:bg-white/5 hover:text-white`}><ChevronLeft className="w-5 h-5" /></button>
      <button onClick={() => { setView("day"); setDate(todayStr()); }} data-testid="fb-date-label" className="flex-1 text-center text-white font-bold text-base sm:text-lg truncate">
        {view === "live" ? "Live now" : view === "fav" ? `Favourites · ${dayLabel(date)}` : dayLabel(date)}
      </button>
      <button onClick={() => { setView("day"); setDate(shift(date, 1)); }} data-testid="fb-date-next" aria-label="Next day" className={`${btn} text-slate-300 hover:bg-white/5 hover:text-white`}><ChevronRight className="w-5 h-5" /></button>
      <span className="relative">
        <button onClick={() => { try { ref.current?.showPicker(); } catch { ref.current?.focus(); } }} data-testid="fb-calendar-btn" aria-label="Pick a date" className={`${btn} bg-[#1A202C] text-slate-200 hover:text-white`}><CalendarDays className="w-5 h-5" /></button>
        <input ref={ref} type="date" value={date} onChange={(e) => { if (e.target.value) { setView("day"); setDate(e.target.value); } }} data-testid="fb-date-input"
          className="absolute inset-0 opacity-0 w-10 h-10 cursor-pointer" aria-label="Match date" />
      </span>
    </div>
  );
}

